import {useEffect, useState} from "react";

export const useIsMobile=()=> {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia('(max-width: 1023px)').matches : false
    )
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1023px)')
        const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
        setIsMobile(mediaQuery.matches)
        mediaQuery.addEventListener('change', handler)
        return () => mediaQuery.removeEventListener('change', handler)
    }, [])

    return isMobile
}